import React, { Component } from "react"
import Util from "../../Util"
import { TableLayout } from "../../components"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { LoadModal } from "../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import { confirmAlert } from "react-confirm-alert"
class TableFiscais extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.print = this.print.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteFiscal(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  print() {
    this.toggleLoadModal()
    ApiHelper.getRelacaoFiscais((file, error) => {
      this.toggleLoadModal()
      if (file) {
        var date = new Date()
        var dateString =
          (date.getDate() + "").padStart(2, "0") +
          "-" +
          (date.getMonth() + "").padStart(2, "0") +
          "-" +
          date.getFullYear()

        var url = URL.createObjectURL(file)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Relação de fiscais cadastrados-" + dateString + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    var buttons = [
      { title: "Criar fiscal", link: "/fiscais/create", icon: "control_point" }
    ]
    var additionalButtons = [
      {
        title: "Imprimir todos os fiscais de contrato",
        callBack: this.print,
        icon: "print"
      }
    ]
    var tableHeaders = [
      "CPF",
      "Nome",
      "Email",
      "Telefone",
      "Unidade orçamentária",
      "Ações"
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          additionalButtons={additionalButtons}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar fiscal"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">
                      {Util.getMaskedCPFCNPJ(row.cpf)}
                    </td>
                    <td className="col-md-3">{row.name}</td>
                    <td className="col-md-2">{row.email}</td>
                    <td className="col-md-2">
                      {Util.getMaskedPhone(row.telefone1)}
                    </td>
                    <td className="col-md-4">
                      {/* {(row.unidade_orcamentaria[0] || { uni_orc: "" }).uni_orc} */}
                      {row.unidade_orcamentaria.map(unidade => unidade.uni_orc).join(" / ")}
                    </td>
                    <td className="td-actions text-right">
                      <Link
                        title="Editar fiscal"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"fiscais/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover fiscal"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableFiscais)



// WEBPACK FOOTER //
// ./src/views/fiscais/TableFiscais.js